// Empty module stub used by vite.config.spa.ts aliases to exclude
// server-only packages from the client SPA bundle.
export default {};
export const getStartContext = () => ({});

// Generic no-op function used for any server-side helper.
const noop: any = () => undefined;
const asyncNoop: any = async () => undefined;

// Request helpers
export const getRequest = noop;
export const getRequestHeader = noop;
export const getRequestHeaders = () => ({});
export const getRequestIP = noop;
export const getRequestHost = noop;
export const getRequestUrl = noop;
export const getRequestProtocol = noop;
export const getRequestMethod = noop;
export const getRequestWebStream = noop;
export const getValidatedQuery = noop;
export const getQuery = () => ({});
export const getRouterParam = noop;
export const readBody = asyncNoop;
export const readRawBody = asyncNoop;
export const readFormData = asyncNoop;
export const readValidatedBody = asyncNoop;

// Response helpers
export const setResponseHeader = noop;
export const setResponseHeaders = noop;
export const setResponseStatus = noop;
export const removeResponseHeader = noop;
export const appendResponseHeader = noop;
export const sendRedirect = noop;
export const send = noop;

// Cookie helpers
export const getCookie = noop;
export const getCookies = () => ({});
export const setCookie = noop;
export const deleteCookie = noop;
export const parseCookies = () => ({});

// Session helpers
export const useSession = async () => ({
  id: undefined,
  data: {},
  update: asyncNoop,
  clear: asyncNoop,
});
export const getSession = asyncNoop;
export const updateSession = asyncNoop;
export const clearSession = asyncNoop;
export const sealSession = asyncNoop;
export const unsealSession = asyncNoop;

// Event/handler helpers
export const createEventHandler = (fn: any) => fn;
export const defineEventHandler = (fn: any) => fn;
export const eventHandler = (fn: any) => fn;
export const getEvent = noop;
export const useEvent = noop;
export const getWebRequest = noop;

// Start/router entry stubs
export const startInstance = {};
export const router = {};
export const createStartHandler = (fn?: any) => fn ?? noop;
export const defaultStreamHandler = noop;
export const defaultRenderHandler = noop;export const streamText = () => {};
export const convertToModelMessages = (msgs: any) => msgs;
export class DefaultChatTransport { constructor(_opts?: any) {} }
export const useChat = (_opts?: any) => ({ messages: [], input: "", setInput: () => {}, handleInputChange: () => {}, handleSubmit: () => {}, append: () => {}, reload: () => {}, stop: () => {}, isLoading: false, error: null, setMessages: () => {}, status: "ready" });

// SPA stubs for @tanstack/react-start exports (s11)
export const createMiddleware = () => ({ server: (fn: any) => fn, client: (fn: any) => fn });
const serverFnChain: any = {
  handler: (fn?: any) => fn ?? noop,
  validator: (_v?: any) => serverFnChain,
  inputValidator: (_v?: any) => serverFnChain,
  outputValidator: (_v?: any) => serverFnChain,
  middleware: (_m?: any) => serverFnChain,
  type: (_t?: any) => serverFnChain,
};
export const createServerFn = (_opts?: any) => serverFnChain;
export const useServerFn = (fn: any) => fn;
export const createStart = (_opts?: any) => ({ middleware: noop });

// AI SDK type stubs (erased at compile time, must exist for resolver)
export type ChatStatus = string;
export type FileUIPart = any;
export type SourceDocumentUIPart = any;
export type UIMessage = any;

// @ai-sdk/openai-compatible
export const createOpenAICompatible = (_opts?: any) => ({
  chatModel: (_id?: string) => ({}),
  completionModel: (_id?: string) => ({}),
  textEmbeddingModel: (_id?: string) => ({}),
});
